import { B as BxfTextArea$1, d as defineCustomElement$1 } from './p-1cb85adc.js';

const BxfTextArea = BxfTextArea$1;
const defineCustomElement = defineCustomElement$1;

export { BxfTextArea, defineCustomElement };
